import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { closeMuzaWidget } from './helpers/helpers';

export function MuzaWidgetWrapper({ link }) {
  const router = useRouter();

  const onRouteChangeStart = () => {
    closeMuzaWidget(link);
  };
  useEffect(() => {
    router.events.on('routeChangeStart', onRouteChangeStart);

    const subscribeListener = (event) => {
      if (event.data === 'CultureWidget__closeModal') {
        closeMuzaWidget(link);
      }
    };
    window.addEventListener('message', subscribeListener);

    return () => {
      router.events.off('routeChangeStart', onRouteChangeStart);
      window.removeEventListener('message', subscribeListener);
      closeMuzaWidget(link);
    };
  }, []);
  return <></>;
}
